import Vue from 'vue'
import App from './App.vue'
import router from './router'

// fontawesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCompass, faUndo, faSignalStream, faWifi, faHeat, faExchange, faLongArrowRight, faLongArrowLeft, faSortAlt, faForward, faRedo } from '@fortawesome/pro-light-svg-icons'
import { faPlay, faPause } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import i18n from './i18n'

library.add(faPlay,faCompass,faUndo,faSignalStream,faWifi,faHeat,faExchange,faLongArrowRight,faLongArrowLeft,faSortAlt,faForward,faRedo,faPause)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: function (h) { return h(App) }
}).$mount('#app')
